import { Keyboard as AriaKeyboard } from 'react-aria-components';
import { type PropsWithChildren, type ReactNode } from 'react';

type KeyboardProps = {
    children?: ReactNode;
};
const Keyboard = ({ children, ...rest }: PropsWithChildren<KeyboardProps>) => {
    return <AriaKeyboard {...rest}>{children}</AriaKeyboard>;
};

export { Keyboard };
export type { KeyboardProps };
